import type { MaybeRefOrGetter, Ref } from "vue";
import { createInjectionState } from "@vueuse/core";
import { useContextOrThrow } from "ls/composables/useContextOrThrow";
import { computed, toValue } from "vue";
import { useSuggestionListNavigation } from "./useSuggestionListNavigation";

export interface SuggestionContextOptions {
  isLoading?: MaybeRefOrGetter<boolean>;
}

const [useProvideSuggestionContext, useSuggestionContextFn] = createInjectionState((searchResults: Ref<unknown[]>, options?: SuggestionContextOptions) => {
  const {
    isLoading = false,
  } = toValue(options) ?? {};

  const searchResultsTotal = computed(() => searchResults.value?.length ?? 0);
  const noResults = computed(() => searchResultsTotal.value === 0);

  const navigation = useSuggestionListNavigation(searchResultsTotal);

  return {
    noResults,
    searchResults,
    searchResultsTotal,
    isOpen: navigation.isOpen,
    onBeforeExit: navigation.onBeforeExit,
    onKeyDown: navigation.onKeyDown,
    handleAfterLeave: navigation.handleAfterLeave,
    reset: navigation.reset,
    select: navigation.select,
    selected: navigation.selected,
    selectedIndex: navigation.selectedIndex,
    isLoading,
  };
});

export { useProvideSuggestionContext };
export const useSuggestionContext = useContextOrThrow(useSuggestionContextFn);
